import { Log } from "../Log";
import { AccountControl } from "./AccountControl";
import { AndonData } from "./Andon";
import { Devices } from "./Devices";

export class AdminData {
  // アカウント一覧画面用
  public accounts: AccountControl = new AccountControl();
  // デバイス一覧画面用
  public devices: Devices = new Devices();

  public log: Log = new Log();
  public andon: AndonData = new AndonData();
  public state: "normal" | "autoUpdate" | "andonUpdate" = "normal";

  public async Update() {
    switch (this.state) {
      case "autoUpdate":
        this.devices.Update();
        break;
      case "andonUpdate":
        this.andon.Update();
        break;
      default:
        break;
    }
  }
}
